import type { UseQueryResult } from "@tanstack/react-query";
import { ApiError } from "@/lib/api/client";
import type { CourseFormSources } from "@/lib/course-form";

/** A transport failure can retain a read; an authority refusal cannot. */
export function placementRead<T>(query: Pick<UseQueryResult<T[]>, "data" | "isPending" | "isError" | "error" | "refetch">): {
  choices: T[]; state: NonNullable<CourseFormSources["placementReads"]>["program"];
} {
  const refused = query.error instanceof ApiError && [401, 403].includes(query.error.status);
  return {
    choices: refused ? [] : query.data ?? [],
    state: { status: query.isPending ? "loading" : query.isError ? query.data && !refused ? "stale" : "failed" : "ready", retry: () => { void query.refetch(); } },
  };
}
